import { useTranslation } from 'react-i18next'

import { FileUpload, FileUploadPlaceholder } from '../../File'
import { FloatingTooltip } from '../../Floating'
import { ICON_HEIGHT_40 } from '../../Icon'

import * as styles from './FilesListUploadItem.module.css'

import UploadIcon from '../../../icons/upload-1.svg'

function FilesListUploadItem({
  uploadedFilesLength,
  onFinishUpload,
  onStartUpload,
  onUploadErrors,
}) {
  const { t } = useTranslation()

  return (
    <FloatingTooltip content={t('FilesGallery.UploadFilesTooltipKey')}>
      <div className={styles.FilesListUploadItem}>
        <FileUpload
          uploadedFilesLength={uploadedFilesLength}
          onFinishUpload={onFinishUpload}
          onStartUpload={onStartUpload}
          onUploadErrors={onUploadErrors}
        >
          <FileUploadPlaceholder
            Icon={UploadIcon}
            className={styles.placeholder}
            iconSize={ICON_HEIGHT_40}
          />
        </FileUpload>
      </div>
    </FloatingTooltip>
  )
}

export default FilesListUploadItem
